
import React, { useContext } from "react";
import { FaAward, FaChartLine, FaHandshake, FaUserTie } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ConsultancyGlobal.css';
import BannerImage from './consultancy_hero.png';

function ISO9001Cons() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-9001-consultancy');
    } else {
      navigate('/login', { state: { from: '/booking/iso-9001-consultancy' } });
    }
  };

  return (
    <div className="consultancy-page">
      <div className="consultancy-max-width">

        {/* --- HERO --- */}
        <div className="consultancy-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Quality Management</span>
          <h1 className="hero-title">ISO 9001 Consultation</h1>
          <p className="hero-subtitle">
            Pursuing excellence in quality management. Streamlining operations to enhance
            customer satisfaction and business performance.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Get Consulted <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Journey to Excellence</h2>
              <p className="article-text">
                ISO 9001 is more than a badge; it is a commitment to quality. It demonstrates that your organization
                follows international standards to ensure consistent products and services. We guide you through the
                complex certification process, turning compliance into a competitive advantage.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Process Approach</h2>
              <p className="article-text">
                We help implement the "Process Approach" and "Risk-based Thinking".
                This means identifying key business processes, defining metrics (KPIs), and ensuring continuous improvement
                (Plan-Do-Check-Act) is embedded in your DNA.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Our Methodology</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Gap Analysis:</strong> Assessing your current status vs ISO standards.</li>
                  <li><strong>Documentation:</strong> Creating lean, usable Quality Manuals.</li>
                  <li><strong>Implementation:</strong> Training staff and embedding processes.</li>
                  <li><strong>Internal Audit:</strong> Preparing you for the final certification audit.</li>
                </ul>
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Why ISO 9001?</h4>
              <ul className="key-list">
                <li><FaChartLine className="check-icon" /> Improved Efficiency</li>
                <li><FaUserTie className="check-icon" /> Customer Satisfaction</li>
                <li><FaAward className="check-icon" /> Global Recognition</li>
                <li><FaHandshake className="check-icon" /> Better Supplier Relations</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Upgrade Quality</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Start your ISO 9001 journey.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ISO9001Cons;
